import { Link, useRouterState } from '@tanstack/react-router';
import { cn } from '@jeraisonne/ui';

const TABS = [
  { id: 'exercises', label: 'Exercices', to: '/tutor/exercises' },
  { id: 'epreuves', label: 'Épreuves', to: '/tutor/epreuves' },
  { id: 'themes', label: 'Thèmes', to: '/tutor/themes' },
  { id: 'skillcards', label: 'SKILLCARDS', to: '/tutor/cards' },
] as const;

export function TutorLibraryTabs() {
  const pathname = useRouterState({ select: (s) => s.location.pathname });

  return (
    // Les 4 onglets tiennent sur 375 px (avant : « SKILLCARDS » coupé hors écran).
    <nav
      aria-label="Bibliothèque"
      className="border-ink-200 -mx-4 mb-5 flex border-b px-2 sm:-mx-6 sm:gap-1 sm:px-6"
    >
      {TABS.map((tab) => {
        const active = pathname.startsWith(tab.to);
        return (
          <Link
            key={tab.id}
            to={tab.to}
            aria-current={active ? 'page' : undefined}
            className={cn(
              'font-display relative inline-flex min-h-[2.75rem] flex-auto items-center justify-center px-1 text-sm font-semibold transition-colors sm:flex-none sm:px-4',
              active ? 'text-primary-700' : 'text-ink-500 hover:text-ink-800',
            )}
          >
            {tab.label}
            {active && (
              <span className="bg-primary-500 absolute inset-x-2 -bottom-px h-0.5 rounded-full" />
            )}
          </Link>
        );
      })}
    </nav>
  );
}
